import React, { useEffect, useState } from 'react';

import loadable from '@loadable/component';
// import { useSelector } from 'react-redux';
// import RenderTest from './RenderTest/RenderTest';

import featureFlags from './util/featureFlags';

import NavContainer from './components/navV2/NavContainer';

const ModalRoot = loadable(() => import('./components/common/ModalRoot'), { ssr: false });
const ToastsContainer = loadable(() => import('./components/toastsContainer'), { ssr: false });
const FeatureToggle = loadable(() => import('./components/FeatureToggle'), { ssr: false });
const SideDrawerRoot = loadable(() => import('./components/common/SideDrawerRoot'), { ssr: false });

function App() {
  const [showFeatureToggle, setShowFeatureToggle] = useState(false);
  // const state = useSelector((appState) => appState);

  useEffect(() => {
    setShowFeatureToggle(featureFlags.get('featureToggle'));
    // eslint-disable-next-line no-console
    console.log('Hydrated client side');
    // console.log('Hydrated client side with initial state', JSON.stringify(state));
  }, []);

  return (
    <React.Fragment>
      {/* <RenderTest /> */}
      <a href="/webaccessibility" tabIndex={0} className="accessibility-link screen-only">
        Web Accessibility
      </a>
      <NavContainer />
      <ModalRoot />
      <SideDrawerRoot />
      <ToastsContainer />
      {showFeatureToggle && <FeatureToggle />}
    </React.Fragment>
  );
}

export default App;
